import type * as Types from './types';

import {
  useQuery,
  type QueryClient,
  type UseQueryOptions,
  type UseQueryResult,
  type FetchQueryOptions,
} from '@tanstack/react-query';
import type { DXError } from '@dx-ui/types-graphql';

export const GetRuleTranslateUrlsFeatureConfigDocument = {
  operationName: 'featureConfigs',
  operationString: `query featureConfigs {
  featureConfigs(names: ["rule-ui-translate-urls"]) {
    name
    conditions
  }
}`,
  originalOpName: 'getRuleTranslateUrlsFeatureConfig',
};

export function useGetRuleTranslateUrlsFeatureConfigQuery<
  TData = Types.GetRuleTranslateUrlsFeatureConfigQuery,
  TError = DXError,
>(
  variables: Types.GetRuleTranslateUrlsFeatureConfigQueryVariables | null = null,
  options?: Omit<
    UseQueryOptions<Types.GetRuleTranslateUrlsFeatureConfigQuery, TError, TData>,
    'queryKey'
  >
): UseQueryResult<TData, TError> {
  return useQuery<Types.GetRuleTranslateUrlsFeatureConfigQuery, TError, TData>({
    queryKey: [GetRuleTranslateUrlsFeatureConfigDocument, variables],
    ...options,
  });
}

export function serverSideGetRuleTranslateUrlsFeatureConfigQuery(
  queryClient: QueryClient,
  variables?: Types.GetRuleTranslateUrlsFeatureConfigQueryVariables,
  options?: FetchQueryOptions<Types.GetRuleTranslateUrlsFeatureConfigQuery>
) {
  return queryClient.fetchQuery<Types.GetRuleTranslateUrlsFeatureConfigQuery>({
    queryKey: [GetRuleTranslateUrlsFeatureConfigDocument, variables ?? {}],
    ...options,
  });
}

export const GetOneLinkFeatureConfigDocument = {
  operationName: 'featureConfigs',
  operationString: `query featureConfigs {
  featureConfigs(names: ["config-ui-translate-onelink"]) {
    name
    config
  }
}`,
  originalOpName: 'getOneLinkFeatureConfig',
};

export function useGetOneLinkFeatureConfigQuery<
  TData = Types.GetOneLinkFeatureConfigQuery,
  TError = DXError,
>(
  variables: Types.GetOneLinkFeatureConfigQueryVariables | null = null,
  options?: Omit<UseQueryOptions<Types.GetOneLinkFeatureConfigQuery, TError, TData>, 'queryKey'>
): UseQueryResult<TData, TError> {
  return useQuery<Types.GetOneLinkFeatureConfigQuery, TError, TData>({
    queryKey: [GetOneLinkFeatureConfigDocument, variables],
    ...options,
  });
}

export function serverSideGetOneLinkFeatureConfigQuery(
  queryClient: QueryClient,
  variables?: Types.GetOneLinkFeatureConfigQueryVariables,
  options?: FetchQueryOptions<Types.GetOneLinkFeatureConfigQuery>
) {
  return queryClient.fetchQuery<Types.GetOneLinkFeatureConfigQuery>({
    queryKey: [GetOneLinkFeatureConfigDocument, variables ?? {}],
    ...options,
  });
}
